import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  useSelector,
  shallowEqual,
} from 'react-redux';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { composeURL, checkObjectAttributes } from '../../utils/urlTools';
import { storeStructure } from '../reducers';
import { loadState } from '../sessionStore';

const Broadcast = (props) => {
  const { eventChanel, sessionParams, onEventReceived } = props;
  const { organization } = loadState();
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);

  const bindEvent = (e) => {
    onEventReceived(e);
  };

  useEffect(() => {
    const server = process.env.REACT_APP_WEBSOCKET;
    window.Pusher = Pusher;

    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: process.env.REACT_APP_PUSHER_KEY,
      wsHost: server,
      disableStats: true,
      encrypted: true,
      enabledTransports: ['ws', 'wss'], // <-- only use ws and wss as valid transports
    });
    return () => {
      window.Echo.disconnect();
    };
  }, []);

  useEffect(() => {
    // createConnectionChanel
    let finalEventChanel = eventChanel;
    if (sessionParams.length > 0 && checkObjectAttributes(session, sessionParams)) {
      finalEventChanel = composeURL(session, sessionParams, eventChanel);
    }
    window.Echo.channel(`${organization}.organization`).listen(`.${finalEventChanel}`, (e) => bindEvent(e));
    return () => {
      window.Echo.channel(`${organization}.organization`).stopListening(`.${finalEventChanel}`);
    };
  }, [session]);

  return (<></>);
};

Broadcast.propTypes = {
  eventChanel: PropTypes.string.isRequired,
  sessionParams: PropTypes.arrayOf(PropTypes.string),
  onEventReceived: PropTypes.func,
};

Broadcast.defaultProps = {
  onEventReceived: () => {},
  sessionParams: [],
};

export default Broadcast;
